<db-dialog-wrapper [dialog]="this" [canClose]="!!currentSubscription?.newPlan || !platformSubscription"
                   [hasCloseButton]="((!!currentSubscription?.newPlan || !platformSubscription) && !this.isAvailableEcommerceFeatures) || (step === 4 && isMobile)"
                   [canCloseByBackdrop]="!platformSubscription || (platformSubscription && step === 2)"
                   [height]="platformSubscription ?  (isMobile ? '100%' : '600px') : '600px'"
                   [width]="platformSubscription ? (((platformSubscription && step == 1 ) || currentSubscription?.isApiResellerPlan ) ? '450px' : '1000px') : '500px'" [animateShow]="false" [withBlackBlur]="isDemoUser">
  <div class="db-account-upgraded-dialog">
    <div *ngIf="extend || !UserSubscriptionCategory.PLATFORM"
         class="db-account-upgraded-dialog__appsumo">
      <div class="db-account-upgraded-dialog__header"
           *ngIf="!extendNotEnough">{{ 'text_accountUpgradedHeader' | dbText }}
      </div>
      <div class="db-account-upgraded-dialog__message"
           *ngIf="!extend && !extendNotEnough">{{ 'text_accountUpgradedDesc' | dbText }}
      </div>
      <div class="db-account-upgraded-dialog__message"
           *ngIf="extend && !extendNotEnough">{{ 'text_accountExtendedDesc' | dbText }}
      </div>


      <div class="db-account-upgraded-dialog__header" *ngIf="extendNotEnough">{{ 'text_sorry' | dbText }}</div>
      <div class="db-account-upgraded-dialog__message"
           *ngIf="extendNotEnough">{{ 'text_accountExtendedNotEnoughDesc' | dbText }}
      </div>
      <div class="db-account-upgraded-dialog__buttons">
        <a class="db-button db-button_info" (click)="close()">
          <span *ngIf="!extendNotEnough">{{ 'text_continue' | dbText | lowerCaseSpecificWords }}</span>
          <span *ngIf="extendNotEnough">{{ 'text_gotIt' | dbText | lowerCaseSpecificWords }}</span>
        </a>
      </div>
    </div>

    <div *ngIf="platformSubscription"
         class="db-account-upgraded-dialog__platform">
      <db-platform-account-upgraded *ngIf="step === 1 && !currentSubscription?.boosterProClient" @slide
                                    [isMobile]="isMobile"
                                    [subscription]="currentSubscription"
                                    [fromBooster]="upgradedFromBooster"
                                    [upgradeableSubscription]="currentSubscription?.category === UserSubscriptionCategory.PERSONAL ? upgradeablePremiumSubscription :
                                    currentSubscription?.category === UserSubscriptionCategory.PREMIUM ? upgradeableEnterpriseSubscription : null"
                                    (onProceed)="close()">
      </db-platform-account-upgraded>
      <db-ecommerce-complete-setup *ngIf="step === 2 && !currentSubscription?.boosterProClient" @slide
                                   [userLocalStorage]="userLocalStorage"
                                   [subscription]="currentSubscription"
                                   [regions]="regions"
                                   (onFinalize)="close(false, $event)">
      </db-ecommerce-complete-setup>
      <db-demo-progress-step *ngIf="step === 3 && !currentSubscription?.boosterProClient" @slide
                             [campaignInfo]="campaignInfo"
                             [currentStep]="currentStep"
                             [subscription]="currentSubscription"
                             [showSetupFlow]="showSetupFlow"
                             [userLocalStorage]="userLocalStorage"
                             [isEcommerceWebsite]="websites && websites[0] && websites[0]?.isEcommerceWebsite"
                             [user]="user"
                             [forceImport]="forceImport"
                             [isAvailableEcommerceFeatures]="isAvailableEcommerceFeatures"
                             [websiteData]="websiteData"
                             (websiteUrlUpdate)="websiteUrlUpdate($event)"
                             (onFinished)="showSuccessStep($event)">
      </db-demo-progress-step>
      <db-demo-progress-done *ngIf="step === 4 && !currentSubscription?.boosterProClient" @slide
                             [campaignInfo]="campaignInfo"
                             [userLocalStorage]="userLocalStorage"
                             [subscription]="currentSubscription"
                             [user]="user"
                             [websiteId]="websiteId"
                             [websiteUrl]="websiteUrl"
                             [pageId]="pageId"
                             [isEcommerce]="tempalteType === 'ecommerce'"
                             [websiteData]="websiteData"
                             (onEditCLick)="_closeAllDialogs()">
      </db-demo-progress-done>
      <db-booster-account-upgraded *ngIf="(step === 1 || step === 2) && currentSubscription?.boosterProClient" @slide
                                   [subscription]="currentSubscription"
                                   [fromBooster]="upgradedFromBooster"
                                   [upgradeableSubscription]="currentSubscription?.category === UserSubscriptionCategory.PERSONAL ? upgradeablePremiumSubscription :
                                    currentSubscription?.category === UserSubscriptionCategory.PREMIUM ? upgradeableEnterpriseSubscription : null"
                                   (onProceed)="close()">
      </db-booster-account-upgraded>
      <div *ngIf="(step === 1 || step === 2) && !currentSubscription?.newPlan && !currentSubscription?.boosterCategory"
           class="db-account-upgraded-dialog__platform-info" @scale
           [ngClass]="{'ecommerce': isAvailableEcommerceFeatures, 'booster' : upgradedFromBooster, 'boosterPro':
            currentSubscription?.boosterProClient}"></div>
      <div *ngIf="step === 4 && !!currentSubscription?.newPlan"
           class="db-account-upgraded-dialog__image">
        <div class="db-image-wrap">
          <div class="db-image" [ngClass]="{'success-ecom': tempalteType === 'ecommerce' && step == 4,
        'success-basic': tempalteType !== 'ecommerce' && step == 4 }"></div>
        </div>
      </div>

      <div class="db-testing-reviews" *ngIf="step === 3">
        <div class="db-review">
          <img src="assets/images/cancel-1wf/quote.svg"/>
          <p class="db-review-text">10Web is a game-changer! The
            <span>Al-powered<br/> builder is incredibly intuitive</span> and makes customization a breeze.</p>
          <div class="db-user"><p>Fatima Aftab</p> <span>10Web user</span></div>
        </div>
        <div class="db-footer">
          <p><span class="doted">1.5M+</span> websites created<br/> with 10Web AI.</p>
          <db-trustpilot [version]="'micro-combo'" [isDark]="true"></db-trustpilot>
        </div>
      </div>
    </div>
  </div>
  <db-loading-screen *ngIf="!!loading" [pageBlocker]="true"></db-loading-screen>
</db-dialog-wrapper>
